import { assignInlineVars } from '@vanilla-extract/dynamic';
import { Property } from 'csstype';
import * as React from 'react';

import * as styles from './heading.css';

type InternalProps<E extends React.ElementType> = {
  as?: E;
  size?: Property.FontSize;
  marginTop?: Property.MarginTop;
  marginBottom?: Property.MarginBottom;
  children?: React.ReactNode;
};

type HeadingProps<E extends React.ElementType> = InternalProps<E> &
  Omit<React.ComponentProps<E>, keyof InternalProps<E>>;

export const Heading = <E extends React.ElementType = 'div'>({
  as,
  size,
  marginTop,
  marginBottom,
  children,
}: HeadingProps<E>) => {
  const TagName = as || 'div';

  return (
    <TagName
      className={styles.root}
      style={{
        ...assignInlineVars({
          [styles.fontSizeVar]: size || '24px',
          [styles.marginTopVar]: marginTop || '0',
          [styles.marginBottomVar]: marginBottom || '0',
        }),
      }}
    >
      {children}
    </TagName>
  );
};
